export default __webpack_public_path__ + "static/media/volcanicrage.b917dbee.png";